import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Dispatch } from "react";
import { Microservices } from "../../../../app/AllowedMicroservices";
import { RootState } from "../../../../app/store";
import apiActionCreator, {
  HttpMethods,
} from "../../../../services/apiActionCreator";
import { FetchStatus } from "../../../common/enums";

interface IInTop10Response {
  onTop10: boolean,
}
interface IInTop10State {
  inTop10: boolean,
  status: FetchStatus,
}
const initialState: IInTop10State = {
  inTop10: false,
  status: FetchStatus.Idle,
};

export const dataSlice = createSlice({
  name: "reportLearningLessonsInTop10",
  initialState,
  reducers: {
    fetching: (state) => {
      state.status = FetchStatus.Fetching;
    },
    fetched: (state, action: PayloadAction<IInTop10Response>) => {
      state.inTop10 = action.payload.onTop10;
      state.status = FetchStatus.Fetched;
    },
    error: (state) => {
      state.status = FetchStatus.Error;
    },
  },
});

export const { fetching, fetched, error } = dataSlice.actions;

export const fetchLessonsInTop10 = () => (dispatch: Dispatch<object>) => {
  let url = '/lessons/onTop10';
  return dispatch(
    apiActionCreator({
      endpoint: url,
      types: {
        requestType: fetching,
        successTypes: [
          {
            actionOrCreator: fetched,
          },
        ],
        errorTypes: [
          {
            actionOrCreator: error,
          },
        ],
      },
      method: HttpMethods.GET,
      microservice: Microservices.LEARNING_SERVICE,
      authenticated: true,
    })
  );
};

export const selectLessonsInTop10 = (state: RootState) => state.reports.learning.lessons.lessonsInTop10.inTop10;
export const selectLessonsInTop10Fetching = (state: RootState) => state.reports.learning.lessons.lessonsInTop10.status === FetchStatus.Fetching;

export default dataSlice.reducer;
